import { Box, Image, Text, VStack } from "@chakra-ui/react"
import React from "react"

import BlurFade from "@/components/Animations/BlurFade"
import ClientZoom from "@/components/ClientZoom"

interface MasonryProps {
  imageSize: number
  items: { alt: string; id: string; img: string; title?: string }[]
  showLegend?: boolean
}

const Masonry: React.FC<MasonryProps> = ({
  imageSize,
  items,
  showLegend = false,
}) => {
  const size = () => {
    switch (imageSize) {
      case 1:
        return {
          column: { base: 6, md: 12, lg: 16 },
          width: "64px",
          zoom: 1.2,
        }
      case 2:
        return {
          column: { base: 4, md: 10, lg: 14 },
          width: "128px",
          zoom: 1.05,
        }
      case 3:
        return {
          column: { base: 2, md: 8, lg: 12 },
          width: "256px",
          zoom: 1.04,
        }
      case 4:
        return {
          column: { base: 1, md: 6, lg: 10 },
          width: "320px",
          zoom: 1.03,
        }
      case 5:
        return {
          column: { base: 1, md: 4, lg: 8 },
          width: "400px",
          zoom: 1.02,
        }
      case 6:
        return {
          column: { base: 1, md: 4, lg: 6 },
          width: "448px",
          zoom: 1.02,
        }
      case 7:
        return {
          column: { base: 1, md: 2, lg: 4 },
          width: "496px",
          zoom: 1.02,
        }
      case 8:
        return {
          column: { base: 1, md: 2, lg: 2 },
          width: "512px",
          zoom: 1.02,
        }
      case 9:
        return { column: { base: 1 }, width: "576px" }
      case 10:
        return { column: { base: 1 }, width: "640px" }
      default:
        return { column: { base: 4, md: 6, lg: 10 }, width: "100px" }
    }
  }
  return (
    <Box
      columnGap={4}
      css={{ columnCount: size().column }}
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="center"
      mx="auto"
      padding={4}
      w="100%"
    >
      {items.map((image, idx) => {
        const imageTitle = image.title?.trim()

        return (
          <BlurFade delay={0.05 + idx * 0.05} inView key={image?.id} w="auto">
            <VStack
              alignItems="flex-start"
              as="figure"
              gap={2}
              m={0}
              mb={2}
              w="auto"
            >
              <ClientZoom>
                {/* TODO: Convert to <Img/> */}
                <Image
                  _hover={{
                    transform: "scale(" + size().zoom + ")",
                  }}
                  alt={image?.alt}
                  aria-label={image?.alt}
                  border="1px solid"
                  borderColor="border.muted"
                  borderRadius="xl"
                  display="inline-block"
                  src={image?.img}
                  transition="transform 0.3s ease-in-out"
                  w={size().width}
                />
              </ClientZoom>
              {showLegend && imageTitle && (
                <Text
                  as="figcaption"
                  color="fg.muted"
                  fontSize="xs"
                  lineHeight="short"
                  maxW={size().width}
                >
                  {imageTitle}
                </Text>
              )}
            </VStack>
          </BlurFade>
        )
      })}
    </Box>
  )
}

export default Masonry
